module.exports = __webpack_public_path__ + "img/searchbar-icon.43324831.png";